// src/components/Gallery/Pictures.styles.ts
import styled from 'styled-components';

import { ErrorMessage, LoadingMessage } from '../Shared/CommonStyles';

/* --- Styled Components --- */

export const PicturesContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;

	& > * {
		width: 100%;
	}

	.ReactGridGallery {
		width: 100%;
	}
`;

export const NoPicturesMessage = styled(LoadingMessage)`
	font-style: italic;
	color: #777;
`;

export const EditControlsContainer = styled.div`
	display: flex;
	flex-direction: column; 
	align-items: flex-start; 
	gap: 8px; 
	margin-bottom: 16px; 
	padding: 10px;
	background-color: #f8f9fa; 
	border-radius: 4px;
	border: 1px solid #e9ecef; 
	width: 100%;
	box-sizing: border-box;

	& > ${ErrorMessage} {
		margin: 0; 
		font-size: 0.9rem;
	}
`;

// Styles for Thumbnail Overlay in Edit Mode
export const ThumbnailOverlayContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.4); 
	display: flex;
	justify-content: center; 
	align-items: center; 
	gap: 8px; 
	opacity: 0; 
	transition: opacity 0.2s ease-in-out; 
	pointer-events: none; 
	border-radius: 2px; 
	z-index: 1; 
`;

export const ThumbnailOverlayButton = styled.button`
	background: rgba(255, 255, 255, 0.8);
	color: #333;
	border: none;
	border-radius: 50%; 
	width: 32px; 
	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	padding: 0;
	font-size: 1rem; 
	transition: background 0.2s ease, transform 0.1s ease;

	z-index: 2; 

	&:hover {
		background: rgba(255, 255, 255, 1);
		transform: scale(1.1);
	}

	&:active {
		transform: scale(1);
	}

	&.delete {
		color: #e74c3c; 
	}
	&.rotate {
		color: #3498db; 
	}
	&.cover {
		color: #f1c40f; 
	}
`;
export const ThumbnailOverlayMessage = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	color: white;
	font-weight: bold;
	text-align: center;
	padding: 10px;
	background: rgba(0, 0, 0, 0.6); 
	border-radius: 2px; 
	pointer-events: none; 
	z-index: 3; 
`;

export const RotationIndicator = styled.div`
	position: absolute;
	top: 5px;
	right: 5px;
	background: rgba(0, 0, 0, 0.7);
	color: white;
	padding: 2px 5px;
	border-radius: 3px;
	font-size: 0.8em;
	z-index: 2; 
	pointer-events: none; 
`;

// Accept $isEditing prop to control hover effect
export const ThumbnailWrapper = styled.div<{
	$isEditing?: boolean;
	$isPendingDelete?: boolean; // Keep this if needed for other styles (like opacity)
}>`
	position: relative; 
	overflow: hidden; 
	border-radius: 2px; 
	display: block; 
	height: 100%; 
    cursor: pointer; 

	${(props) =>
		props.$isEditing &&
		`
	   &:hover ${ThumbnailOverlayContainer} {

	     opacity: 1;
	     pointer-events: all; 

	   }
	 `}
`;

export const ThumbnailImage = styled.img`
	object-fit: cover;
	width: 100%;
	height: 100%;
`;

export const SecretNoticeContainer = styled.div`
	background-color: #fff3cd;
	color: #856404;
	border: 1px solid #ffeeba;
	padding: 12px 16px;
	border-radius: 4px;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 0.95rem;
`;

export const SecretNoticeButton = styled.button`
	background-color: #856404;
	color: white;
	border: none;
	padding: 6px 12px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 0.9rem;
	margin-left: 10px;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #6d5204;
	}
`;

export const ToggleAllContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 16px;
	background-color: #f8f9fa;
	border-radius: 4px;
	border: 1px solid #e9ecef;
	margin-bottom: 16px;
	flex-wrap: wrap;
`;

export const ToggleAllButton = styled.button`
	background-color: #856404;
	color: white;
	border: none;
	padding: 6px 12px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 0.85rem;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #6d5204;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const ShowAllPhotosButton = styled.button`
	background-color: #17a2b8;
	color: white;
	border: none;
	padding: 8px 16px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 0.9rem;
	margin-left: auto;
	margin-right: auto;
	display: block;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #138496;
	}
`;
